import { FAQProps } from 'lib/components/FAQ/FAQ'
import { NarrativeHeroProps } from 'lib/components/NarrativeHero/NarrativeHero'
import { NewsletterSignupProps } from 'lib/components/NewsletterSignup/NewsletterSignup'

import { faqItems } from '@/components/shipplay/content/faqItems'
import { StructuredData } from '@/utils/brand'

export interface FAQPageContent {
  hero: NarrativeHeroProps
  faq: FAQProps
  newsletter: NewsletterSignupProps
  structuredData?: StructuredData
}

const hero: NarrativeHeroProps = {
  header: 'Frequently Asked Questions',
  subHeader: 'Browse common queries or select a topic below to narrow your search.',
}

// Ship&Play renders its FAQ via ShipplayFAQPage (see src/app/faq/page.tsx), which
// reads faqItems directly. This object only satisfies the brand.pageContent
// contract, so it derives from that same single source of truth instead of
// duplicating the questions here.
const categories = [...new Set(faqItems.map((item) => item.category))].map(
  (categoryName, index) => ({ categoryName, categoryId: index + 1 }),
)

const categoryIdByName = new Map(categories.map((c) => [c.categoryName, c.categoryId]))

const faq: FAQProps = {
  subtitle: 'Please choose a topic below to better pinpoint your question you may have.',
  title: (
    <>
      Have questions?
      <br />
      <b>We have answers.</b>
    </>
  ),
  categories,
  items: faqItems.map(({ question, answer, category }) => ({
    question,
    answer,
    categoryName: category,
    categoryId: categoryIdByName.get(category),
  })),
  button: {
    moreText: 'View More FAQs',
  },
  variant: 'white',
}

const newsletter: NewsletterSignupProps = {
  title: 'Stay up to date. Join our newsletter.',
  brand: 'shipplay',
}

// No structuredData here: the Ship&Play FAQ page emits its own FAQPage JSON-LD
// (see ShipplayFAQPage), derived from the same faqItems.
const content: FAQPageContent = {
  hero,
  faq,
  newsletter,
}

export default content
